module.exports = __webpack_public_path__ + "static/img/img_apply@2x.f018a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/talents/img_apply@2x.png
// module id = bhQ9
// module chunks = 0